import { render, staticRenderFns } from "./chatbox.vue?vue&type=template&id=308ff2af&"
import script from "./chatbox.vue?vue&type=script&lang=js&"
export * from "./chatbox.vue?vue&type=script&lang=js&"
import style0 from "./chatbox.vue?vue&type=style&index=0&id=308ff2af&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/baikaifa/Desktop/codes/baikaifa-overwrite-skeleton-webpack-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308ff2af')) {
      api.createRecord('308ff2af', component.options)
    } else {
      api.reload('308ff2af', component.options)
    }
    module.hot.accept("./chatbox.vue?vue&type=template&id=308ff2af&", function () {
      api.rerender('308ff2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "preview/components/chatbox.vue"
export default component.exports